var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36.924,
    height: 36.923,
    viewBox: "0 0 36.924 36.923",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:url(#a);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#094674"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05233a"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M32.967,2.25H3.956A3.957,3.957,0,0,0,0,6.206V35.217a3.957,3.957,0,0,0,3.956,3.956H32.967a3.957,3.957,0,0,0,3.956-3.956V6.206A3.957,3.957,0,0,0,32.967,2.25Zm-4.03,13.088c.016.231.016.47.016.7A15.274,15.274,0,0,1,13.574,31.417a15.309,15.309,0,0,1-8.3-2.423,11.388,11.388,0,0,0,1.3.066,10.838,10.838,0,0,0,6.709-2.308A5.413,5.413,0,0,1,8.234,23a5.826,5.826,0,0,0,2.44-.1A5.406,5.406,0,0,1,6.346,17.6V17.53a5.4,5.4,0,0,0,2.44.684,5.394,5.394,0,0,1-2.407-4.5,5.338,5.338,0,0,1,.734-2.728A15.348,15.348,0,0,0,18.256,16.64,5.417,5.417,0,0,1,27.478,11.7a10.592,10.592,0,0,0,3.429-1.3,5.391,5.391,0,0,1-2.374,2.975,10.757,10.757,0,0,0,3.115-.841A11.378,11.378,0,0,1,28.937,15.338Z",
    transform: "translate(0 -2.25)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.65319bcbf071f7d938d200cb498d12c5.svg";
export { ForwardRef as ReactComponent };